export default __webpack_public_path__ + "static/alex-d9337954b022db8ab2274301dadf31ae.jpg";